import { useState } from "react"
import { DialogOverlay, DialogContent } from "@reach/dialog"
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js"
import { Button } from "app/core/components/Button"
import LabeledCreditCardField from "app/core/components/LabeledCreditCardField"
import Form from "app/core/components/Form"
import { logger } from "utils/logger"
import Sentry from "integrations/sentry"
import toast from "react-hot-toast"

const createSetupIntent = async (stripeCustomerId: string) => {
  const res = await fetch("/api/stripe/createSetupIntent", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ stripeCustomerId }),
  })
  const data = await res.json()
  return data.clientSecret
}

const UpdatePaymentForm = ({ isOpen, onClose, stripeCustomerId }) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)

  const stripe = useStripe()
  const elements = useElements()

  const handleSubmit = async (event) => {
    setLoading(true)
    setError(null)

    if (!stripe || !elements) {
      return
    }

    const clientSecret = await createSetupIntent(stripeCustomerId)

    const { error: stripeError, setupIntent } = await stripe.confirmCardSetup(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement)!,
      },
    })

    if (error) {
      toast(() => (
        <div>Error with update payment information. Please contact ellen@homeschoolboss.com</div>
      ))
      setLoading(false)
      return
    } else {
      await fetch("/api/stripe/updateDefaultPaymentMethod", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          paymentMethodId: setupIntent!.payment_method,
          stripeCustomerId,
        }),
      })
    }

    setSuccess(true)
    setLoading(false)
    onClose()
  }

  return (
    <DialogOverlay
      isOpen={isOpen}
      onDismiss={onClose}
      className="modal--small ixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
    >
      <DialogContent className="modal-content g-white p-6 rounded-lg w-96 shadow-lg relative">
        <h2 className="mb-4">Update Payment Information</h2>

        <Form onSubmit={handleSubmit}>
          <div className="payment-form mb-4">
            <LabeledCreditCardField
              name="creditCard"
              label="Credit Card"
              outerProps={{ className: "col-span-full" }}
            />
          </div>
          <div className="flex justify-end space-x-2">
            <Button
              type="button"
              onClick={onClose}
              className="bg-gray-300 text-gray-700 hover:bg-gray-400"
            >
              Cancel
            </Button>
            <Button type="submit" disabled={loading || !stripe}>
              {loading ? "Updating..." : "Update Payment"}
            </Button>
          </div>
        </Form>
      </DialogContent>
    </DialogOverlay>
  )
}

export default UpdatePaymentForm
